import { Card, TextField } from '@mui/material'
import Grid from '@mui/material/Grid'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import AppData from './components/data-tables/data/dataTableData'
import CreateModal from './components/CreateModal'
import Loader from 'examples/Loader'
import { useEffect, useState } from 'react'
import { DateRangePicker } from 'rsuite'
import 'rsuite/dist/rsuite.min.css'
import CustomDataTable from '../Users/CustomDataTable'

function Default() {
  const {
    dataTableData,
    handleRefresh,
    products,
    apps,
    loader,
    setDateRange,
    dateRange,
    pagination,
    handlePageChange,
    handleLimitChange,
    search,
    setSearch,
    handleSearch,
  } = AppData()

  const [typingTimeout, setTypingTimeout] = useState(null)

  const handleDebouncedSearch = (value) => {
    setSearch(value)
    if (value.trim() === '') {
      if (typingTimeout) clearTimeout(typingTimeout)
      handleSearch()
      return
    }
    if (typingTimeout) clearTimeout(typingTimeout)
    const timeout = setTimeout(() => {
      handleSearch()
    }, 1000)
    setTypingTimeout(timeout)
  }

  const onLoad = () => { }
  useEffect(onLoad, [])

  return (
    <DashboardLayout>
      {loader ? (
        <Loader />
      ) : (
        <>
          <DashboardNavbar />
          <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <Card>
                  <MDBox
                    mx={2}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <MDTypography variant="h6" color="white">
                      Listing (Total: {pagination?.totalUsers || 0})
                    </MDTypography>
                    <CreateModal products={products} apps={apps} handleRefresh={handleRefresh} />
                  </MDBox>
                  <MDBox pt={3} px={3}>
                    <Grid container spacing={2} alignItems="center" mb={2}>
                      <Grid item>
                        <DateRangePicker
                          placeholder="Filter by date range"
                          value={
                            dateRange.startDate && dateRange.endDate
                              ? [new Date(dateRange?.startDate), new Date(dateRange?.endDate)]
                              : null
                          }
                          onChange={(range) => {
                            if (range) {
                              setDateRange({
                                startDate: range[0],
                                endDate: range[1],
                              })
                            } else {
                              setDateRange({ startDate: null, endDate: null })
                            }
                          }}
                          style={{
                            marginBottom: '8px',
                            backgroundColor: 'white',
                            borderRadius: '8px',
                          }}
                        />
                      </Grid>
                      <Grid item display="flex" alignItems="center" gap={1}>
                        <TextField
                          variant="outlined"
                          size="small"
                          placeholder="Search listings..."
                          value={search}
                          onChange={(e) => handleDebouncedSearch(e.target.value)}
                          sx={{
                            backgroundColor: 'white',
                            borderRadius: '8px',
                            width: 250,
                          }}
                        />
                      </Grid>
                    </Grid>
                    <CustomDataTable
                      table={dataTableData}
                      canSearch={false}
                      entriesPerPage={{
                        defaultValue: pagination?.limit || 10,
                        entries: [5, 10, 15, 20, 25],
                      }}
                      pagination={pagination}
                      onPageChange={handlePageChange}
                      onLimitChange={handleLimitChange}
                    />
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </>
      )}
    </DashboardLayout>
  )
}

export default Default
